<script>
export default {
  props: {
    showLocationCompanyModal: Boolean,
    myPosition: {type: Object, default: () => {
        return {
            lat: '',
            lng: '',
            nombre: ''
        }
    }}
  },
  data() {
    return {
      mapCenter: { lat: 40.333333, lng: -4.187500 },
      mapZoom: 7,
      //Options Map (Gmap)
      options: {
        mapId: '9582e7dfb5f80cf6',
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        clickableIcons: false
      },
    };
  },
  computed: {
    modalTitle() {
      const nameCompany = this.myPosition?.nombre;
      return 'Localización ' + nameCompany;
    }
  },
};
</script>


<template>
  
  <b-modal id="ModalMapCompnay" :title="modalTitle" :size="'lg'">
    <gmap-map ref="map" :center="myPosition" :options="options" :zoom="mapZoom" style="height: 50vh">
      <gmap-marker :position="myPosition">
        <gmap-info-window :options="{pixelOffset: { width: 0, height: -15 }}" v-if="showLocationCompanyModal" >
          Latitud: {{ myPosition.lat }}<br>Longitud: {{ myPosition.lng }}
        </gmap-info-window>
      </gmap-marker>
    </gmap-map>
    <template #modal-footer="{  }">
      <b-button @click="cancelForm()">Cancel</b-button>
    </template>
  </b-modal>
</template>